export const createReadOnlyForm = (form, rowsSetup) => {
  if (!form || !form.id) return rowsSetup;
   
  return rowsSetup.map(row => {
    return row.map(col => {
      let newCol = Object.assign({}, col);
      newCol.value = form[newCol.colKey];

      return newCol;
    });
  });
};